import { render, staticRenderFns } from "./LoginNavigationBar.vue?vue&type=template&id=1235908c&scoped=true&"
import script from "./LoginNavigationBar.vue?vue&type=script&lang=js&"
export * from "./LoginNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./LoginNavigationBar.vue?vue&type=style&index=0&id=1235908c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235908c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VFooter,VSpacer})
